import { createTheme } from '@mui/material/styles';

const baseTheme = createTheme({
	palette: {
		type: 'light',
		background: {
			default: '#f8f8f8',
			darker: '#a5a291'
		},
		header: {
			default: '#2f56a9'
		},
		disabled: {
			light: '#e5e5e5',
			main: '#f9f9f9'
		},
		success: {
			main: '#58a758'
		},
		error: {
			main: '#cd5c5c'
		},
		warning: {
			main: '#cbcb04'
		},
		common: {
			white: '#ffffff',
			black: '#000000',
			gray: '#ccc'
		},
		primary: {
			main: '#2f56a9'
		},
		secondary: {
			main: '#5c709f'
		}
	}
});

export default baseTheme;
